import routeConfig from "@irati-web/app/src/routeConfig"

export const PERKS = "perks"
export const RECOGNITION = "recognition"
export const REWARD = "reward"
export const MEDICAL = "medical"
export const WALLET = "wallet"
export const PLATFORM = "platform"
export const ONBOARDING = "onboarding"
export const TOUR = "tour"
export const WELLNESS = "wellness"
export const HOMEPAGE = "homepage"
export const ADMIN = "admin"

export const routeToProduct = {
  [routeConfig.FLEXIREWARDS]: REWARD,
  [routeConfig.HOME]: HOMEPAGE,
  [routeConfig.MEDICAL]: MEDICAL,
  [routeConfig.ONBOARDING]: ONBOARDING,
  [routeConfig.PERKS]: PERKS,
  [routeConfig.RECOGNITION]: RECOGNITION,
  [routeConfig.WALLET]: WALLET,
  [routeConfig.WELLNESS]: WELLNESS,
  [routeConfig.WELCOME]: ONBOARDING,
  [routeConfig.ADMIN]: ADMIN
}
